import React, { useState } from "react";
import { updatePPDStatusApi } from "../../../services/OtherService";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const ApproveReviewModal = ({
    user,
    data,
    handleAfterApproved,
}) => {
    const [showModal, setShowModal] = useState(false);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [approvalStatus, setApprovalStatus] = useState("");
    const [rejectedReason, setRejectedReason] = useState("");

    const getFutureStatus = (sta) => {
        let status = "Reviewed"
        if (sta === "Reviewed") {
            status = "Approved"
        } else if (sta === "Rejected") {
            status = "Rejected"
        }
        return status
    }

    const getFutureStatusHeading = (sta) => {
        let status = "Review"
        if (sta === "Reviewed") {
            status = "Approve"
        } else if (sta === "Rejected") {
            status = "Rejected"
        }
        return status
    }

    const toggleModal = () => {
        if (showModal) {
            setRejectedReason("")
            setApprovalStatus("")
        } else {
            setApprovalStatus(getFutureStatus(data?.status))
            setRejectedReason(data?.rejected_reason || "")
        }
        setShowModal(!showModal);
    };

    const handlestatus = (e) => {
        setApprovalStatus(e.target.value);
    };
    const isButtonClickable = () => {
        if (user.role === "Admin") {
            return true
        }
        if (data?.status === "Pending") {
            return user?.user_permission?.review_purchase_demand
        } else if (data?.status === "Reviewed") {
            return user?.user_permission?.approve_purchase_demand
        } else if (data?.status === "Rejected") {
            if (data?.reviewed_by) {
                return user?.user_permission?.approve_purchase_demand
            } else {
                return user.user_permission.review_purchase_demand
            }
        } return true
    }


    const handleApprove = async () => {
        if (isSubmiting || !isButtonClickable) {
            return;
        }
        try {
            setIsSubmiting(true);
            const payload = { status: approvalStatus };
            if (approvalStatus === "Rejected") {
                payload.rejected_reason = rejectedReason;
            }
            const response = await updatePPDStatusApi(payload, data.id);
            const result = response.data;
            handleAfterApproved(result);
            toast.success("Status Updated Successfully");
            toggleModal();
        } catch (error) {
            console.log("error", error)
            toast.error(error.response?.data?.error || "An error occurred");
        } finally {
            setIsSubmiting(false);
        }
    };

    const handleReview = async () => {
        if (isSubmiting || !isButtonClickable) return;
        try {
            setIsSubmiting(true);
            const payload = {
                status: approvalStatus === "Rejected" ? "Rejected" : "Reviewed",
            };
            if (approvalStatus === "Rejected") {
                payload.rejected_reason = rejectedReason;
            }
            const response = await updatePPDStatusApi(payload, data.id);
            const result = response.data
            handleAfterApproved(result); // Callback after verification
            toast.success("Status Updated Successfully");
            toggleModal();
        } catch (error) {
            console.log("error", error)
            toast.error(error.response?.data?.error || "An error occurred");
        } finally {
            setIsSubmiting(false);
        }
    };

    return (
        <>
            <span
                className={`btn ${data.status == "Pending" ? 'btn-warning' : data?.status === "Reviewed" ? 'btn-info' : data?.status === "Rejected" ? "btn-danger" : "btn-success"} ${isButtonClickable ? "cursor-pointer" : "disabled"
                    }`}
                onClick={() => isButtonClickable() && toggleModal()}
                style={{ fontSize: "0.9rem" }}
            >
                {data.status}
            </span>
            <Modal
                className="modal fade"
                id="exampleModal3"
                show={showModal}
                onHide={() => toggleModal()}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h4>
                            <strong>
                                {getFutureStatusHeading(data?.status)} PPD{" "}
                            </strong>
                        </h4>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => toggleModal()}
                        ></button>
                    </div>

                    <div className="modal-body p-4">
                        {((data?.status === "Reviewed") || (data?.status === "Rejected" && data?.reviewed_by)) ? (
                            <div>
                                <div className="mb-3">
                                    <h5>Are you sure you want to approve this PPD?</h5>
                                    <p>
                                        Once approved, this PPD will be marked as approved, and
                                        no further changes can be made.
                                    </p>
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-lable me-4">Status: </label>
                                    <div className="form-check custom-checkbox mb-2 form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="ApprovedRadio"
                                            value="Approved"
                                            name="status"
                                            onChange={handlestatus}
                                            checked={approvalStatus === "Approved"}
                                        />
                                        <label className="form-check-label" htmlFor="ApprovedRadio">
                                            Approved
                                        </label>
                                    </div>

                                    <div className="form-check custom-checkbox mb-2 form-check-inline">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            id="RejectedRadio"
                                            value="Rejected"
                                            name="status"
                                            onChange={handlestatus}
                                            checked={approvalStatus === "Rejected"}
                                        />
                                        <label className="form-check-label" htmlFor="RejectedRadio">
                                            Rejected
                                        </label>
                                    </div>
                                </div>

                                {approvalStatus === "Rejected" && (
                                    <div className="form-group mb-3">
                                        <label htmlFor="form-label">Rejected Reason</label>
                                        <textarea
                                            className="form-control"
                                            name="rejectedReason"
                                            required
                                            onChange={(e) => setRejectedReason(e.target.value)}
                                            value={rejectedReason}
                                            placeholder="Enter Rejected Reason"
                                        ></textarea>
                                    </div>
                                )}

                                <div className="d-flex align-items-center justify-content-center">
                                    <button
                                        type="submit"
                                        className="btn btn-outline-primary btn-sm me-1"
                                        onClick={handleApprove}
                                        disabled={!isButtonClickable || isSubmiting}
                                    >
                                        {approvalStatus === "Approved"
                                            ? isSubmiting
                                                ? "Approving..."
                                                : "Approve"
                                            : isSubmiting
                                                ? "Rejecting..."
                                                : "Reject"}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-danger ms-2"
                                        onClick={() => toggleModal()}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        ) : ((data?.status === "Pending") || (data?.status === "Rejected" && data?.reviewed_by === null)) ? (
                            <div>
                                <div className="mb-3">
                                    <h5>
                                        Are you sure you want to update the status of this PPD to  Reviewed?
                                    </h5>
                                    <p>
                                        Once reviewed, this PPD will be marked as reviewed.
                                    </p>
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-lable me-4">Status: </label>
                                    <div className="form-check custom-checkbox mb-2 form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id="ApprovedRadio"
                                            value="Reviewed"
                                            name="status"
                                            onChange={handlestatus}
                                            checked={approvalStatus === "Reviewed"}
                                        />
                                        <label className="form-check-label" htmlFor="ApprovedRadio">
                                            Reviewed
                                        </label>
                                    </div>

                                    <div className="form-check custom-checkbox mb-2 form-check-inline">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            id="RejectedRadio"
                                            value="Rejected"
                                            name="status"
                                            onChange={handlestatus}
                                            checked={approvalStatus === "Rejected"}
                                        />
                                        <label className="form-check-label" htmlFor="RejectedRadio">
                                            Rejected
                                        </label>
                                    </div>
                                </div>

                                {approvalStatus === "Rejected" && (
                                    <div className="form-group mb-3">
                                        <label htmlFor="form-label">Rejected Reason</label>
                                        <textarea
                                            className="form-control"
                                            name="rejectedReason"
                                            onChange={(e) => setRejectedReason(e.target.value)}
                                            value={rejectedReason}
                                            placeholder="Enter Rejected Reason"
                                        ></textarea>
                                    </div>
                                )}

                                <div className="d-flex align-items-center justify-content-center">
                                    <button
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={handleReview}
                                        type="button"
                                        disabled={!isButtonClickable || isSubmiting}
                                    >
                                        {isSubmiting ? "Submiting..." : "Submit"}
                                    </button>
                                    <button
                                        className="btn btn-sm btn-danger ms-2"
                                        type="button"
                                        onClick={() => toggleModal()}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <h4 className="text-center mb-4">
                                    This PPD has already been approved.
                                </h4>


                                <div className="d-flex align-items-center justify-content-center">
                                    <button
                                        className="btn btn-sm btn-danger ms-2"
                                        type="button"
                                        onClick={() => toggleModal()}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        </>
    );
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

export default connect(mapStateToProps)(ApproveReviewModal);